/* eslint-disable */

import axios from "axios";

const url = require("../../client_config/config").url;

const state = {
    client: null,
    clients: [],
    activeClients: []
};

const getters = {
    clientData: (state) => state.client
};

const actions = {
    async getClient({commit}, id) {
        try {
            const response = await axios.get(`${url}/clients/${id}`);
            commit("SET_CLIENT", response.data.client[0]);
            return response.data.client[0];
        } catch (error) {
            return error.response;
        }
    },

    async downloadCSV({commit}) {
        try {
            const response = await axios.get(`${url}/clients/generate/csv`);
            return response.data;
        } catch (error) {
            console.error(error.response);
            return error.response;
        }
    },

    async getAllClients({commit}) {
        try {
            const response = await axios.get(`${url}/clients`);
            commit("SET_ALL_CLIENT", response.data.clients);
            return response.data.clients;
        } catch (error) {
            console.error(error.response);
            return error.response;
        }
    },

    async getAllActiveClients({commit}, userState) {
        try {
            let params = {};
            params['Status'] = 'Active';
            const response = await axios.get(`${url}/clients`, {params});
            commit("SET_ALL_ACTIVE_CLIENT", response.data.clients);
            return response.data.clients;
        } catch (error) {
            console.error(error.response);
            return error.response;
        }
    },

};

const mutations = {
    SET_CLIENT(state, data) {
        state.client = data;
    },

    SET_ALL_CLIENT(state, data) {
        state.clients = data;
    },

    SET_ALL_ACTIVE_CLIENT(state, data) {
        state.activeClients = data
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
